import { render, staticRenderFns } from "./TypeSector.vue?vue&type=template&id=0d5637ae&"
import script from "./TypeSector.vue?vue&type=script&lang=js&"
export * from "./TypeSector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports